import { DyteSpinner } from "@dytesdk/react-ui-kit";
import { useSearchParams } from "react-router-dom";

import { useMeeting } from "../../../../hooks/useMeeting";
import { useLiveMeetingAnalysis } from "../../../../hooks/useMeetingAnalysis";
import ConvDynamics from "./components/ConvDynamics";
import { MeetingSummary } from "./components/MeetingSummary";
import { ResourcesShared } from "./components/ResourcesShared";
import { RiskMonitor } from "./components/RiskMonitor";

export function PostSession() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("sessionId");

  const { data: meeting } = useMeeting(sessionId!);
  const { data: meetingAnalysis } = useLiveMeetingAnalysis(sessionId!);
  console.log("MEETING: ", meeting);

  if (!meeting) {
    return (
      <div className="flex h-full flex-col items-center justify-center">
        <DyteSpinner />
        <p className="text-gray-500">Loading analysis...</p>
      </div>
    );
  }

  return (
    <div className="main-content mx-auto max-w-7xl rounded-lg bg-white p-8 shadow-lg">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <MeetingSummary meeting={meeting} analysis={meetingAnalysis} />
        <ConvDynamics analysis={meetingAnalysis} />
        <RiskMonitor analysis={meetingAnalysis} />
        <ResourcesShared analysis={meetingAnalysis} />
      </div>
    </div>
  );
}
